import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ssrSafeStorage } from './utils';

interface SettingsState {
    thumbnails_enabled: boolean;
    record_details_enabled: boolean;
    points_compact_enabled: boolean;
    staff_mode: boolean;
    opened_dev_preview_warning: boolean;
    setThumbnailsEnabled: (enabled: boolean) => void;
    setRecordDetailsEnabled: (enabled: boolean) => void;
    setPointsCompactEnabled: (enabled: boolean) => void;
    setStaffMode: (enabled: boolean) => void;
    setOpenedDevPreviewWarning: (opened: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
    persist(
        (set) => ({
            thumbnails_enabled: true,
            record_details_enabled: true,
            points_compact_enabled: true,
            staff_mode: true,
            opened_dev_preview_warning: true,
            setThumbnailsEnabled: (enabled: boolean) => {
                set({ thumbnails_enabled: enabled });
            },
            setRecordDetailsEnabled: (enabled: boolean) => {
                set({ record_details_enabled: enabled });
            },
            setPointsCompactEnabled: (enabled: boolean) => {
                set({ points_compact_enabled: enabled });
            },
            setStaffMode: (enabled: boolean) => {
                set({ staff_mode: enabled });
            },
            setOpenedDevPreviewWarning: (opened: boolean) => {
                set({ opened_dev_preview_warning: opened });
            },
        }),
        {
            name: 'settings',
            storage: ssrSafeStorage,
        },
    ),
);
